import React, { useState } from 'react'
import './index.css'
import './index.mobile.css' // Assurez-vous que le chemin du fichier CSS est correct.
import Navigation from './Navigation'
import Menu from '../Menu/Menu'
import Footer from '../Footer/Footer'
import Part4 from './part4/Part4'
import Part3 from './part3/Part3'
import Part2 from './part2/Part2'
import Part1 from './part1/Part1'
import { createVisite } from '../../api/Visites'
import { ProfilType } from './Profil.type'
import swal from 'sweetalert'
import PageFinal from './PageFinal'
import { createNotifications } from '../../api/Notifications'

interface ProgrammationVisiteProps {
  authState: {
    email: string
    connectedAccountID: string
    firstname: string
    lastname: string
    phoneNumber: string
    createdAt: Date
    updatedAt: Date
    userImg: string
    birthdate: string
    city: string
    isVisiteur: boolean
    isVerifiedStripeAccount: boolean
  }
  authProps: {
    token: string
    isLoggedIn: boolean
    setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>
  }
}

const ProgrammationVisite: React.FC<ProgrammationVisiteProps> = ({
  authState,
  authProps,
}: ProgrammationVisiteProps) => {
  const [showLastPart, setShowLastPart] = useState(false)
  const [missingValue, setMissingValue] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formData, setFormData] = useState<{
    date: Date
    heureVisite: string
    noDateYet: boolean
    proprietaire: string
    adresseBien: string
    ville: string
    codePostal: string
    typeBien: string
    prix: { email: string; prix: number }[]
    informationsComplementaires: string
    selectedProfiles: ProfilType[]
  }>({
    date: new Date(),
    heureVisite: '',
    noDateYet: false,
    proprietaire: '',
    adresseBien: '',
    ville: '',
    codePostal: '',
    typeBien: '',
    prix: [],
    informationsComplementaires: '',
    selectedProfiles: [],
  })

  const { token } = authProps

  const [formDataValidPart1, setFormDataValidPart1] = useState({
    date: false,
    heureVisite: false,
  })
  const [formDataValidPart2, setFormDataValidPart2] = useState({
    proprietaire: false,
    adresseBien: false,
    ville: false,
    codePostal: false,
    typeBien: false,
  })
  const [formDataValidPart3, setFormDataValidPart3] = useState({
    selectedProfile: false,
  })

  const componentsToRender = [
    <Part1
      key='1'
      setFormData={setFormData}
      formData={formData}
      setFormDataValid={setFormDataValidPart1}
      formDataValid={formDataValidPart1}
    />,
    <Part2
      key='2'
      setFormData={setFormData}
      formData={formData}
      setFormDataValid={setFormDataValidPart2}
      formDataValid={formDataValidPart2}
    />,
    <Part3
      key='3'
      setFormData={setFormData}
      formData={formData}
      setFormDataValid={setFormDataValidPart3}
      formDataValid={formDataValidPart3}
      token={authProps.token}
      userEmail={authState.email}
    />,
    <Part4 key='3' setFormData={setFormData} formData={formData} />,
  ]

  const handleFormSubmit = async () => {
    try {
      if (formData) {
        if (!formData.noDateYet && (!formData.date || !formData.heureVisite)) {
          swal(
            'Date requise',
            'Merci de renseigner une date et une heure avant d’envoyer la demande.',
            {
              icon: 'info',
            },
          )
          return
        }

        // Selon la source des profils, `profileVisiteur.email` peut être absent.
        // Fallback sur `profil.email` pour éviter d'envoyer "undefined" au backend (notifications).
        const visiteursEmail = formData.selectedProfiles
          .map((profil) => profil.profileVisiteur?.email || profil.email)
          .filter(Boolean)
        const visiteurId = formData.selectedProfiles.map((profil) => profil.profileVisiteur.id)

        const visite = {
          date: formData.date,
          heureVisite: formData.heureVisite,
          proprietaire: formData.proprietaire,
          adresseBien: formData.adresseBien,
          ville: formData.ville,
          codePostal: formData.codePostal,
          typeBien: formData.typeBien,
          email: visiteursEmail,
          visiteurId: visiteurId,
          prix: formData.prix,
          informationsComplementaires: formData.informationsComplementaires,
        }

        const response = await createVisite(token, visite)

        if (response.success) {
          for (const visite of response.visites) {
            const data = {
              type: 'Visite',
              content: null,
              userImg: authState.userImg,
              firstName: authState.firstname,
              lastName: authState.lastname,
              chatId: visite.chatId,
            }

            await createNotifications(token, authState.firstname, visiteursEmail, data)
          }
          window.scrollTo({ top: 0, behavior: 'smooth' })
          window.localStorage.removeItem('basketToFinish')
          setIsLoading(true)
          setTimeout(() => {
            setShowLastPart(true)
            setIsLoading(false)
          }, 500)
        } else {
          swal('Erreur ! Une erreur est survenue dans votre demande de visite !', {
            icon: 'error',
          })
        }
      }
    } catch (error) {
      console.error('Erreur lors de la création du profil visiteur', error)
    }
  }

  return (
    <div className='min-h-screen bg-[#FFF7F1]'>
      <Menu authState={authState} authProps={authProps} />

      <main className='pt-[92px] sm:pt-[104px] pb-16'>
        <div className='mx-auto w-full max-w-6xl px-4 sm:px-6'>
          {showLastPart ? (
            <div className='rounded-3xl border border-black/10 bg-white/70 shadow-sm overflow-hidden'>
              <div className='px-4 py-8 sm:px-10 sm:py-12'>
                <PageFinal totalProfiles={formData.selectedProfiles.length} />
              </div>
            </div>
          ) : (
            <div className='rounded-3xl border border-black/10 bg-white/70 shadow-sm overflow-hidden'>
              <header className='relative px-4 py-8 sm:px-10 sm:py-10 border-b border-black/5'>
                <div className='inline-flex items-center rounded-full border border-black/10 bg-white/60 px-3 py-1 text-xs font-semibold text-gray-700'>
                  Programmation
                </div>

                <h1 className='mt-4 text-2xl sm:text-4xl font-extrabold tracking-tight text-gray-900 max-w-4xl'>
                  {/* eslint-disable-next-line react/no-unescaped-entities */}
                  Programmer la visite d&apos;un bien par l&apos;un de nos visiteurs
                </h1>
                <p className='mt-3 text-sm sm:text-base text-gray-700 max-w-3xl leading-7'>
                  Renseignez les informations essentielles, choisissez un visiteur disponible et
                  envoyez votre demande en quelques étapes.
                </p>

                <svg
                  className='hidden md:block absolute right-10 top-10'
                  xmlns='http://www.w3.org/2000/svg'
                  width='187'
                  height='84'
                  viewBox='0 0 187 84'
                  fill='none'
                  aria-hidden='true'
                >
                  <path
                    d='M154.556 6.23943C120.112 -0.524946 43.0276 -4.1608 10.2418 35.4108C-30.7403 84.8753 92.0328 86.1848 138.769 78.5337C166.733 73.9558 185 62.755 185 46.5498C185 32.5982 153.281 11.6298 95.8738 15.5933'
                    stroke='url(#paint0_linear_105_2012)'
                    strokeWidth='4'
                    strokeLinecap='round'
                  />
                  <defs>
                    <linearGradient
                      id='paint0_linear_105_2012'
                      x1='2'
                      y1='2'
                      x2='131.982'
                      y2='134.149'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stopColor='#F40000' />
                      <stop offset='1' stopColor='#F75000' />
                    </linearGradient>
                  </defs>
                </svg>
              </header>

              <section className='px-4 py-8 sm:px-10 sm:py-10'>
                {isLoading ? (
                  <div className='flex min-h-[220px] items-center justify-center'>
                    <div className='h-12 w-12 rounded-full border-4 border-black/10 border-t-[#f75000] animate-spin' />
                  </div>
                ) : (
                  <Navigation
                    formData={formData}
                    setFormData={setFormData}
                    authProps={authProps}
                    components={componentsToRender}
                    validation={[formDataValidPart1, formDataValidPart2, formDataValidPart3]}
                    handleFormSubmit={handleFormSubmit}
                    missingValue={missingValue}
                    setMissingValue={setMissingValue}
                  />
                )}
              </section>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default ProgrammationVisite
